import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import axios from 'axios'
Vue.prototype.$http = axios
// Vue.prototype.$apiUrl = 'http://test.h5api.xiaoxxx.cn/h5/zebra10'
Vue.prototype.$apiUrl = 'https://h5api.xiaoxxx.cn/h5/zebra10'
// Vue.prototype.$apiUrl = (window.location.hostname === 'zebra.xiaoxxx.cn') ? 'https://zebra.xiaoxxx.cn/zhuanZebra/' : 'http://test.zebra.xiaoxxx.cn/zhuanZebra/'
axios.defaults.baseURL = `${Vue.prototype.$apiUrl}`
axios.interceptors.request.use((config) => {
    if (localStorage.getItem('Authorization')) {
      config.headers.Authorization = localStorage.getItem('Authorization');
    }
    return config;
  });
Vue.config.productionTip = false

// 设置rem
function setRem() {
  var deviceWidth = document.documentElement.clientWidth;
  if (deviceWidth > 750) {
    deviceWidth = 7.5 * 50;
  }

  document.documentElement.style.fontSize = deviceWidth / 7.5 + "px";

  var lastTouchEnd = 0;
  document.documentElement.addEventListener(
    "touchend",
    function (event) {
      var now = Date.now();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    },
    false
  );

  if (document.getElementsByTagName("meta")["viewport"]) {
    document.getElementsByTagName("meta")["viewport"].content =
      "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0";
  } else {
    var meta = document.createElement("meta");
    meta.content =
      "width=device-width, initial-scale=1.0, maximum-scale=1.0,minimum-scale=1.0, user-scalable=0";
    meta.name = "viewport";
    document.getElementsByTagName("head")[0].appendChild(meta);
  }
}
setRem();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
